<template lang="pug">
// 弹出框查看
.resultDialog
    el-form(ref='resultform', :model='resultform', :rules='rules', label-width='160px')
        
        baseForm(:fatherdata="rowdata",:rowid="id")

        el-row( type="flex" class="line_box" justify="space-between")
            div 协商结果信息
        
        el-form-item(label='应到:', prop='allPeopleNum')
            el-input(size='mini', style='width:50%', placeholder='请输入', v-model='resultform.allPeopleNum',:disabled="disableds")
        el-form-item(label='缺席:', prop='absentPeopleNum')
            el-input(size='mini', style='width:50%', placeholder='请输入', v-model='resultform.absentPeopleNum',:disabled="disableds")
        el-form-item(label='主持人:', prop='moderator')
            el-input(size='mini', style='width:50%', placeholder='请输入', v-model='resultform.moderator',:disabled="disableds")
        el-form-item(label='记录人:', prop='recorder')
            el-input(size='mini', style='width:50%', placeholder='请输入', v-model='resultform.recorder',:disabled="disableds")

        el-form-item(label='协商结果: ', prop='result')
            el-radio-group(v-model='resultform.result',:disabled="disableds")
                el-radio(label='2') 协商已达成
                el-radio(label='1') 协商未达成

        el-form-item(label='协商结果描述:', prop='results', style='margin-top: 10px;margin-bottom: 120px')
            quillEditor(v-model='resultform.results', :options='editorOption', style='height:150px',:disabled="disableds")

        el-form-item(label='协商结果附件：', prop='enclosure')
            el-upload(name='file', :limit='3', :on-exceed='handleExceed', :on-success='uploadSuccess', :file-list='fileList', :action='uploadUrl', :on-remove='handleRemove', :on-preview='handlePreview')
                el-button(size='small', type='primary') 点击上传
                span.el-upload__tip(slot='tip')    附件大小不超过2M

        el-form-item(label='协商结果跟踪:', prop='trackPersonId', style='margin-top: 10px;')
            el-tag(v-if='resultform.trackPersonId',    :disable-transitions='false', type= 'info')
                | {{resultform.trackPersonName}} 
            el-button.button-new-tag(v-if="!disableds",size='small', @click="showPersonSelected('xiezhu')") 选择人员
        

    .boontbtn
        el-button(type='primary', size='small', style='margin: 0 30px', @click='saveData') 保存
        el-button(type='info', size='small', @click='closeDialog') 关闭
    div
        el-dialog(title='选择人员', :visible.sync='checkpeop', width='900px', @close="closeDialogPerson",:append-to-body="false",:modal-append-to-body="false" :modal="false")
            ViewPeople(@func='selectedPersons',:choosedata="checkpeopData",:isshow="checkpeop")

</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import editor_option from "../../../../utils/editorOption.js";
import request from "../../../../utils/request.js";
import { consulApiDetail, consulApiUpdateResults } from "@/api/http.js";
import ViewPeople from "./peopleRadioDialog.vue";
import baseForm from "./baseForm.vue";

let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: "ViewResult",
  props: ["rowid", "show"],
  components: {
    quillEditor,
    ViewPeople,
    baseForm
  },
  data() {
    return {
      resultform: {},
      checkpeopTypeData: [],
      checkpeopData: [],
      id: this.rowid,
      editorOption: editor_option.editorOption,
      rowdata: {
        responsible: [],
        assist: []
      },
      uploadUrl: request.defaults.baseURL + "/admin/consul/info/uplodfiles",
      videoFlag: false,
      videoUploadPercent: 0,
      checkpeop: false,
      isShow: false,
      checkpeopFlag: "fuzeren",
      fileList: [],
      rules: {
        allPeopleNum: [
          { required: true, message: "请输入应到人数", trigger: "blur" }
        ],
        absentPeopleNum: [
          { required: true, message: "请输入缺席人数", trigger: "blur" }
        ],
        moderator: [
          { required: true, message: "请输入主持人", trigger: "blur" }
        ],
        recorder: [
          { required: true, message: "请输入记录人", trigger: "blur" }
        ],
        results: [
          { required: true, message: "请输入协商结果描述", trigger: "blur" }
        ],
        result: [
          { required: true, message: "请选择协商结果", trigger: "change" }
        ],
        trackPersonId: [
          { required: true, message: "请选择协商结果跟踪人", trigger: "blur" }
        ]
      },
      disableds: false
    };
  },

  methods: {
    //附件预览
    handlePreview(file) {
      window.open(file.url);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    //上传
    handleExceed(files, fileList) {
      var selected = files.length;
      var totalselected = selected + fileList.length;
      this.$message.warning(
        "当前限制选择3个文件，本次选择了" +
          selected +
          "个文件，共选择了" +
          totalselected +
          "个文件"
      );
    },
    //确保每次只能上传一个文件，可多次上传
    uploadSuccess(response, file, fileList) {
      console.log(response);
      if (response.code == 200) {
        this.fileList.push({
          name: response.content.name,
          url: response.content.path
        });
      }
    },
    //点击查看显示弹出层
    async getData() {
      this.rowdata = {
        interestParty: [],
        someoneElse: []
      };
      if (this.id) {
        //获取编辑项的最新数据
        let fd = new FormData();
        fd.append("token", token);
        fd.append("id", this.id);

        var res = await consulApiDetail(fd);
        // console.log(res)
        if (res.code == 200) {
          this.rowdata = res.content;
          //将字符串类型转换整型，select框中返回ID为整型
          this.rowdata.orgPid = 5; //parseInt(this.rowdata.orgPid)
          this.rowdata.orgId = parseInt(this.rowdata.orgId);

          this.resultform = {
            allPeopleNum: res.content.allPeopleNum,
            absentPeopleNum: res.content.absentPeopleNum,
            moderator: res.content.moderator,
            recorder: res.content.recorder,
            result: res.content.result,
            results: res.content.results,
            trackPersonId: res.content.trackPersonId,
            personPhone: res.content.personPhone,
            trackPersonName:res.content.trackPersonName
          };
        } else {
          this.rowdata = {};
          console.log(res.code + "：" + res.message);
          this.$message({
            message: "数据项加载异常",
            type: "error"
          });
        }
      } else {
        this.$message({
          message: "数据传输异常",
          type: "error"
        });
        this.rowdata = {};
        this.$emit("func", []);
      }
    },
    beforeUploadVideo(file) {
      const isLt10M = file.size / 1024 / 1024 < 20;
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb"
        ].indexOf(file.type) == -1
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传视频大小不能超过20MB哦!");
        return false;
      }
    },
    //上传进度
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage;
    },
    handleVideoSuccess(res, file) {
      //获取上传图片地址
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      console.log(res);
      if (res.code == 200) {
        this.rowdata.video = res.content.path;
      } else {
        this.$message.error("视频上传失败，请重新上传！");
      }
    },
    showPersonSelected(flag) {
      this.checkpeop = true;
      this.checkpeopFlag = flag;
    },
    handleClose() {
      //   console.log('ff66');
      this.resultform.trackPersonId = "";
      this.$set(this.resultform, "trackPersonId", "");
      this.$set(this.resultform, "trackPersonName", "");
      this.$set(this.resultform, "personPhone", "");
      //   this.resultform.trackPersonName = "";
      //   this.resultform.personPhone = "";
    },
    selectedPersons(data) {
      this.checkpeop = false;
      this.resultform.trackPersonName = data.trackPersonName;
      this.resultform.trackPersonId = data.trackPersonId;
      this.resultform.personPhone = data.personPhone;
    },

    saveData() {
      this.$refs.resultform.validate(valid => {
        if (valid) {
          this.saveData2();
        } else {
          this.$message({
            message: "请输入正确信息",
            type: "error"
          });
          return false;
        }
      });
    },
    //审批接口
    async saveData2() {
      let fd = new FormData();
      fd.append("token", token);
      if (this.fileList.length > 0) {
         this.$set(this.resultform,'video','')
        this.fileList.forEach(item => {
          this.resultform.video = this.resultform.video + "," + item.url;
        });
      }
      this.$set(this.resultform,'id',this.rowid)
      let params = JSON.stringify(this.resultform);
      console.log('this.fileList',this.fileList)
      
      fd.append("delayConsult", params);
      console.log(fd);
      var res = await consulApiUpdateResults(params);
      if (res.code == 200) {
        this.$message({
          message: "录入结果成功",
          type: "success"
        });
        this.$emit("func", "resultSummary");
      } else {
        console.log(res);
        this.$message({
          message: "录入结果失败：" + res.message,
          type: "error"
        });
      }
    },
    closeDialog() {
      this.$emit("func", "resultSummary");
    },
    closeDialogPerson() {
      //   this.$set(this, "isShow", false);
      this.isShow = false;
      this.checkpeop = false;
    }
  },
  mounted() {
    this.getData();
  },
  watch: {
    rowid(val) {
      if (val) {
        this.id = val;
        this.getData();
      } else {
        this.resultform = {};
        this.rowdata = {
          interestParty: [],
          someoneElse: []
        };
      }
    },
    show(val) {
      if (val) {
        this.disableds = true;
      } else {
        this.disableds = false;
      }
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.avatar {
  width: 50%;
  float: left;
}
.boontbtn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.el-upload {
  border: 1px dotted #ccc;
  padding: 0 15px;
}
</style>
<style lang="less">
.main[data-v-336d350d] {
  min-width: 1578px !important ;
}
.el-form-item {
  margin-bottom: 6px;
}

.resultDialog {
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
</style>